module.exports = __webpack_public_path__ + "static/img/Man Shoes.0a8ffa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/Man Shoes.jpg
// module id = I0GG
// module chunks = 1